import React from 'react';

function InformationConfirmation({data, employeesList}) {
    const {generalInformation, employeesInformation} = data;

    return (
        <div className="account-info">
            <div className="header">Corporate Account</div>
            <div className="form-container">

                <div className="form-title">
                    COMPANY INFORMATION
                </div>
                <div className="info-container">
                    <div className="info-value">
                        <div className="info-title">Company Registered Name</div>
                        <div className="info">{generalInformation?.RegisteredName}</div>
                    </div>

                    <div className="info-value">
                        <div className="info-title">Address</div>
                        <div className="info">{generalInformation?.PhoneNumber}</div>
                    </div>

                    <div className="info-value">
                        <div className="info-title">Email</div>
                        <div className="info">{generalInformation?.Email}</div>
                    </div>

                    <div className="info-value">
                        <div className="info-title">Address</div>
                        <div className="info">{generalInformation?.Address}</div>
                    </div>

                </div>

                <div className="form-title">
                    EMPLOYEES INFORMATION
                </div>
                <div className="info-container">
                    {
                        (employeesList && employeesList.Superadmin.length!==0) &&
                        <div className="info-value employees">
                            <div className="info-title">Superadmin</div>
                            {
                                employeesList.Superadmin.map((value) => (

                                    <div className="employees-info">
                                        <div className="info">{value}</div>
                                    </div>
                                ))
                            }
                        </div>
                    }

                    {(employeesList && employeesList.Admin.length!==0) &&
                        <div className="info-value employees">
                            <div className="info-title">Admin</div>
                            {
                                employeesList.Admin.map((value) => (

                                    <div className="employees-info">
                                        <div className="info">{value}</div>
                                    </div>
                                ))
                            }
                        </div>
                    }

                    {(employeesList && employeesList.Viewer.length!==0) &&
                        <div className="info-value employees">
                            <div className="info-title">Viewer</div>
                            {
                                employeesList && employeesList.Viewer.map(( value) => (

                                    <div className="employees-info">
                                        <div className="info">{value}</div>
                                    </div>
                                ))
                            }
                        </div>
                    }

                    {/*<div className="info-value employees">*/}
                    {/*    <div className="info-title">Superadmin</div>*/}
                    {/*    <div className="employees-info">*/}
                    {/*        <div className="info">Romy Saber</div>*/}
                    {/*        <div className="info">Aya Joumaa</div>*/}
                    {/*    </div>*/}
                    {/*</div>*/}

                    {/*<div className="info-value employees">*/}
                    {/*    <div className="info-title">Admin</div>*/}
                    {/*    <div className="employees-info">*/}
                    {/*        <div className="info">Mark Haddad</div>*/}
                    {/*        <div className="info">Mark Haddad</div>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                </div>

            </div>
        </div>
    );
}

export default InformationConfirmation;